export const LIVE_MODE_TRANSLATE = 'translate';
export const LIVE_MODE_CHATTING = 'livechat';